<wk-icon-filled-more-sprite-pds3 />
<wk-settings-breadcrumb (breadcrumbNavigate)="onBreadcrumbNavigate($event)" />
<div class="wk-sfc__content">
    <div class="wk-sfc__dashboard-select">
        <wk-dashboard-select
            [showDashboardRenameOption]="false"
            (canChangeDashboard)="canChangeDashboard($event)"
            (dashboardChangeCompleted)="dashboardChangeCompleted($event)"
        />
    </div>
    <div class="wk-sfc__header">
        {{ "Settings.ReturnCategoriesHeading" | translate }}
        @if (!isJobsBillingDashboard) {
            <div class="wk-sfc__rwt">
                <label class="wk-sfc__rwt-label">{{ "Settings.TagsCatchAllList" | translate }}</label>
                <select-field-pds3 cg3-theme="PDS-v3" size="medium" class="wk-sfc__rwt-select">
                    <select (change)="catchAllTagsToggle($event.target.value)">
                        <option [value]="false" [selected]="AssignCategoryNoTags === false && AssignCategoryId === ''">
                            {{ "Settings.CatchAllTagsOptions.Off" | translate }}
                        </option>
                        @if (isLastOneToTheRightTagVisible == true) {
                            <option [value]="true" [selected]="AssignCategoryNoTags === true">
                                {{ "Settings.CatchAllTagsOptions.On" | translate }}
                            </option>
                        } @else {
                            @for (category of fileCategoryModel.Categories; track category.Id) {
                                <option [value]="category.Id" [selected]="category.Id === AssignCategoryId">
                                    {{ category.Name | wkTranslate }}
                                </option>
                            }
                        }
                    </select>
                </select-field-pds3>
            </div>
        }
    </div>
    @if (isJobsBillingDashboard) {
        <div class="wk-sfc__jb">
            <notification-pds3 type="warning" notificationRole="alert">
                <h3 *notificationHeadingPds3>{{ "Settings.ReturnCategoriesJobsBillingWarningTitle" | translate }}</h3>
                <span *notificationContentPds3> {{ "Settings.ReturnCategoriesJobsBillingWarning" | translate }}</span>
            </notification-pds3>
        </div>
    } @else {
        <div class="wk-sfc__container">
            <div class="wk-sfc__categories-section">
                <div class="wk-sfc__categories-section__titles">
                    <div class="wk-sfc__categories-section__category wk-sfc__categories-section__title">{{ "Dashboard.Categories" | translate }}</div>
                    <div class="wk-sfc__categories-section__tags wk-sfc__categories-section__title">
                        {{ "FiltersSidebar.Labels.Tags" | translate }}
                    </div>
                </div>
                <div class="wk-sfc__categories-section__content">
                    @if (showCategories) {
                        <wk-drop-list
                            id="categories"
                            groupId="ReturnCategories"
                            [cdkDropListData]="fileCategoryModel.Categories"
                            cdkDropListOrientation="horizontal"
                            [cdkDropListDisabled]="isDashboardChanging()"
                            (drop)="onDrop()"
                            class="wk-sfc__categories fancy-scrollbar-newUI"
                            cdkScrollable
                        >
                            @for (category of fileCategoryModel.Categories; track category.Id) {
                                <wk-drag [cdkDragData]="category" class="wk-sfc__category">
                                    <div class="wk-sfc__category-header">
                                        <div
                                            class="wk-sfc__category-header__title"
                                            position="bottom"
                                            kendoTooltip
                                            title=""
                                            (mouseover)="showTooltip($event)"
                                        >
                                            {{ category.Name | wkTranslate }}
                                        </div>
                                        <div class="wk-sfc__category-header__actions">
                                            <span [id]="'category-actions_' + $index">
                                                <icon-pds3 flowClass="target-icon" name="wk-icon-filled-more" />
                                            </span>
                                            <dropdown-pds3
                                                [targetSelector]="'#category-actions_' + $index"
                                                menuMode="application"
                                                srLabelledby="button2"
                                            >
                                                <dropdown-list-pds3 menuMode="application">
                                                    <dropdown-item-field-pds3 *dropdownListItemPds3>
                                                        <button type="button" (click)="editCategory(category)">
                                                            <wk-icon-pencil-sprite-pds3 />
                                                            <icon-pds3 name="wk-icon-pencil" class="icon-pencil" />
                                                            <span>{{ "Settings.ReturnCategoriesDropdownOption_Edit" | translate }}</span>
                                                        </button>
                                                    </dropdown-item-field-pds3>
                                                    <dropdown-item-field-pds3 *dropdownListItemPds3>
                                                        <button type="button" (click)="showDeletePopup(category.Id, $index)" class="icon-trash">
                                                            <wk-icon-trash-sprite-pds3 />
                                                            <icon-pds3 name="wk-icon-trash" />
                                                            <span>{{ "General.Delete" | translate }}</span>
                                                        </button>
                                                    </dropdown-item-field-pds3>
                                                </dropdown-list-pds3>
                                            </dropdown-pds3>
                                        </div>
                                    </div>
                                    <wk-drop-list
                                        [id]="`categoryTags${$index}`"
                                        groupId="Tags"
                                        [cdkDropListData]="category.Tags"
                                        cdkDropListOrientation="mixed"
                                        (drop)="onDrop()"
                                        class="wk-sfc__category-list fancy-scrollbar-newUI"
                                    >
                                        @for (tag of category.Tags; track $index) {
                                            <wk-drag [cdkDragData]="tag" class="wk-sfc__tag">
                                                <tag-pds3 type="dark" [flowClass]="'cg3-tag-' + tag.Id"> {{ tag.Name | wkTranslate }} </tag-pds3>
                                            </wk-drag>
                                        }
                                    </wk-drop-list>
                                </wk-drag>
                            }
                        </wk-drop-list>
                    }
                    <div class="wk-sfc__category-add" [class.wk-drag-dragging]="isDragging()" (click)="addCategory()">+</div>
                </div>
            </div>
            <div class="wk-sfc__unassigned-tags-section">
                <div class="wk-sfc__unassigned-tags-section__titles">
                    <div class="wk-sfc__unassigned-tags-section__title">
                        {{ "Settings.UnassignedTags" | translate }}
                    </div>
                </div>
                <div class="wk-sfc__unassigned-tags-section__content">
                    <wk-drop-list
                        id="unassignedTags"
                        groupId="Tags"
                        [cdkDropListData]="fileCategoryModel.tagsModel"
                        cdkDropListOrientation="mixed"
                        (drop)="onDrop()"
                        class="wk-sfc__dragfield fancy-scrollbar-newUI wk-sfc__unassigned-tags-section__container"
                    >
                        @for (tag of fileCategoryModel.tagsModel; track $index) {
                            <wk-drag [cdkDragData]="tag" class="wk-sfc__tag">
                                <tag-pds3 type="dark" [flowClass]="'cg3-tag-' + tag.Id"> {{ tag.Name | wkTranslate }} </tag-pds3>
                            </wk-drag>
                        }
                    </wk-drop-list>
                </div>
            </div>
        </div>
    }
    <div class="wk-sfc__actions">
        @if (!isJobsBillingDashboard) {
            <button class="btn-primary wk-sfc__actions-save" [disabled]="!isFormChanged()" (click)="onSave()">
                @if (categoriesService.isSaving > 0) {
                    <app-loader class="wk-save-button-loader-spacing" [isOverlay]="false" size="button" />
                }
                {{ "Settings.Save" | translate }}
            </button>
        }
        <button class="btn-secondary wk-sfc__actions-cancel" (click)="onCancelChanges()">
            {{ "General.Close" | translate }}
        </button>
    </div>
</div>

<ng-template #deleteDialogContent>
    <div class="wk-sfc__delete-dialog">
        <div class="modal-header wk-sfc__delete-dialog__header">
            <h3 class="modal-title wk-sfc__delete-dialog__header-title">{{ "Settings.DeleteCategory" | translate }}</h3>
            <wk-icon-filled-close-sprite-pds3 />
            <icon-pds3 name="wk-icon-filled-close" (click)="bsModalRef.hide()" class="wk-sfc__delete-dialog__header-close" />
        </div>
        <div class="modal-body wk-sfc__delete-dialog__body">
            <div class="wk-sfc__delete-dialog__body-heading">
                {{ "Settings.ReturnCategoriesDeleteHeading" | translate }}
            </div>
            <ul>
                <li>
                    {{ ProfileName }}
                </li>
            </ul>
            <div class="wk-sfc__delete-dialog__actions">
                <button class="btn-primary wk-sfc__delete-dialog__actions-delete" (click)="onConfirm(true)">
                    {{ "General.Delete" | translate }}
                </button>
                <button class="btn-secondary wk-sfc__delete-dialog__actions-cancel" (click)="bsModalRef.hide()">
                    {{ "Settings.btnCancel" | translate }}
                </button>
            </div>
        </div>
    </div>
</ng-template>

<div kendoDialogContainer></div>
